import { Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import type { MRT_ColumnDef, MRT_RowData } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../../../mantine/mrt/components/cell/MantineIconCell";
import { ControlledMantineEditAddressInfo } from "../../../../../../mantine/mrt/components/edit/ControlledMantineEditAddressInfo";
import { THEME_VARS } from "../../../../../../utils/constants";

export function getAddressColumn<T extends MRT_RowData>(
  hasCellError: (rowIndex: number, accessorKey: keyof T) => boolean
): MRT_ColumnDef<T> {
  return {
    accessorKey: "tenantAddress",
    header: "Adresse des Mieters",
    Edit: ({ row, cell, column }) => {
      return (
        <ControlledMantineEditAddressInfo
          allowInput
          cell={cell}
          columnId={column.id}
          row={row}
        />
      );
    },
    Cell: ({ row }) => (
      <>
        {row.original.tenantAddress.address} {row.original.tenantAddress.zip}{" "}
        {row.original.tenantAddress.city}
        {hasCellError(row.index, "tenantAddress") && (
          <MantineIconCell
            iconColor={THEME_VARS.error[6]}
            IconComponent={IconAlertTriangle}
            renderedCellValue={
              <Text c="error">Bitte tragen Sie einen Wert ein.</Text>
            }
          />
        )}
      </>
    )
  };
}
